import { SEARCH_STUDENTS, SELECTED_PROFILE, SEARCH_ORGANIZATION, STUDENT_LOOKUP, SET_INITIAL_GPA, SET_ACTIVATED_GPA } from './types'

const normalize = (value) => (value ?? '').trim();

const customCompare = (strA, strB) => {
    const a = normalize(strA);
    const b = normalize(strB);
    
    const aLower = a.toLowerCase();
    const bLower = b.toLowerCase();
    
    const aStartsWithDigit = /^\d/.test(aLower);
    const bStartsWithDigit = /^\d/.test(bLower);
    
    // Si ambos empiezan con dígito
    if (aStartsWithDigit && bStartsWithDigit) {
        if (aLower < bLower) return -1;
        if (aLower > bLower) return 1;
        return 0;
    }
    
    if (aStartsWithDigit) return -1;
    if (bStartsWithDigit) return 1;
    
    const comparison = aLower.localeCompare(bLower, undefined, { numeric: true });
    
    if (comparison === 0 && a !== b) {
        for (let i = 0; i < Math.min(a.length, b.length); i++) {
            const charA = a[i];
            const charB = b[i];
            
            if (charA !== charB) {
                const isUpperA = charA === charA.toUpperCase() && charA !== charA.toLowerCase();
                const isUpperB = charB === charB.toUpperCase() && charB !== charB.toLowerCase();
                
                if (isUpperA && !isUpperB) return -1;
                if (!isUpperA && isUpperB) return 1;
            }
        }
    }
    
    return comparison;
};

const sortStudentsByName = (students = []) => {
    if (!Array.isArray(students)) {
        return [];
    }

    return [...students].sort((studentA, studentB) => {
        const nameA = normalize(studentA?.studentName);
        const nameB = normalize(studentB?.studentName);
        
        const nameComparison = customCompare(nameA, nameB);
        
        if (nameComparison !== 0) {
            return nameComparison;
        }
        
        const idComparison = customCompare(
            normalize(studentA?.studentID), 
            normalize(studentB?.studentID)
        );
        if (idComparison !== 0) {
            return idComparison;
        }
        
        return Number(studentA?.studentUID ?? 0) - Number(studentB?.studentUID ?? 0);
    });
};

export const setInitailaGPA = (ActivatedGPA) => async (dispatch) => {
    await dispatch({
        type: SET_INITIAL_GPA,
        payload: { ...ActivatedGPA }
    });
};

export const setActivatedGPA = (ActivatedGPA) => async (dispatch) => {
    await dispatch({
        type: SET_ACTIVATED_GPA,
        payload: { ...ActivatedGPA }
    });
};

export const getSearchStudents = (allStudents) => async (dispatch) => {
    await dispatch({
        type: SEARCH_STUDENTS,
        payload: sortStudentsByName(allStudents)
    });
};

export const getSelectedProfiles = (profile) => async (dispatch) => {
    await dispatch({
        type: SELECTED_PROFILE,
        payload: { ...profile }
    });
};

export const getSearchOrg = (org) => async (dispatch) => {
    await dispatch({
        type: SEARCH_ORGANIZATION,
        payload: [...org]
    });
};

export const getStudentLookup = (data) => async (dispatch) => {
    await dispatch({
        type: STUDENT_LOOKUP,
        payload: sortStudentsByName(data)
    });
};